import React from "react";
import { Card, CardBody, Button } from "@heroui/react";

interface DashboardCardProps {
  title: string;
  subtitle?: string;
  backgroundImage?: string;
  actionText?: string;
  onAction?: () => void;
  children?: React.ReactNode;
}

export const DashboardCard = ({
  title,
  subtitle,
  backgroundImage,
  actionText,
  onAction,
  children,
}: DashboardCardProps) => {
  return (
    <Card
      isPressable={!!onAction}
      onPress={onAction}
      className="border-none h-full overflow-hidden rounded-xl cursor-pointer"
      style={{
        backgroundImage: backgroundImage
          ? `url(${backgroundImage})`
          : undefined,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundColor: "rgb(23, 23, 23)",
      }}
    >
      <CardBody className="p-0 h-full flex flex-col relative">
        {/* Main content area */}
        <div className="flex-1 p-6">
          {children}
        </div>

        {/* Frosted label section with button */}
        <div className="p-1.5">
          <div className="relative rounded-xl overflow-hidden">
            {/* Frosted glass effect background */}
            <div className="absolute inset-0 bg-black/40 backdrop-blur-md" />
            
            {/* Content */}
            <div className="relative z-10 p-3 sm:p-4">
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4">
                <div className="flex-1">
                  <h3 className="text-base sm:text-lg font-normal text-white">{title}</h3>
                  {subtitle && (
                    <p className="text-xs sm:text-sm font-thin text-gray-300">{subtitle}</p>
                  )}
                </div>
                
                {actionText && onAction && (
                  <Button
                    color="default"
                    size="sm"
                    radius="full"
                    onPress={onAction}
                    className="bg-white text-black font-normal px-4 sm:px-6 text-sm sm:text-base w-full sm:w-auto"
                  >
                    {actionText}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
